/**
 * Domain Redirect Arm
 * 
 * Simple module-level flag that gates cross-domain redirects.
 * DomainEnforcer only redirects when this flag is true.
 * 
 * Armed by: explicit user UI actions (language selector, location selector)
 * Disarmed by: DomainEnforcer after firing a redirect
 * 
 * This prevents DB-driven or init-driven locale/location from
 * triggering unwanted cross-domain redirects on page load.
 */

let _armed = false;

/** Arm the redirect — called when user explicitly changes locale or location */
export function armDomainRedirect(): void {
  _armed = true;
}

/** Disarm — called after redirect fires or on reset */
export function disarmDomainRedirect(): void {
  _armed = false;
}

/** Check if redirect is armed */
export function isDomainRedirectArmed(): boolean {
  return _armed;
}
